module.exports = __webpack_public_path__ + "static/Mentr-f23d7a058740f30ad733ba3042087803.jpg";